import { useBaseMutation } from "../../../../hooks/useBaseMutation";

export const usePutUserToStore = () => {
    return useBaseMutation(
        'put',
        'https://api.menufy.link/restaurantBackend/stores/users', // Updated endpoint for users
    );
};
